// @flow

import * as React from 'react';

import Columns from 'app/components/commons/Columns';
import Section from 'app/components/commons/Section';
import t from 'app/utils/translate';
import { Grid, PriceButton } from './components';

export type ContestType = 'h2h' | 'multi_players';

type Props = {
  contestType: ContestType,
  disabled: boolean,
  isPrivate: boolean,
  onSelectContestType: ContestType => void,
  onSelectPrivate: boolean => void
};

const ContestTypeSection = ({
  contestType,
  disabled,
  isPrivate,
  onSelectContestType,
  onSelectPrivate
}: Props) => (
  <Columns>
    <div className="column is-half">
      <Section title={`${t('Challenge')} type`}>
        <Grid>
          <PriceButton
            selected={contestType === 'h2h'}
            onClick={() => (!disabled ? onSelectContestType('h2h') : undefined)}
          >
            HEAD TO HEAD
          </PriceButton>
          <PriceButton
            selected={contestType === 'multi_players'}
            onClick={() => (!disabled ? onSelectContestType('multi_players') : undefined)}
          >
            MULTI PLAYERS
          </PriceButton>
        </Grid>
      </Section>
    </div>
    <div className="column is-half">
      <Section title="OPPONENT">
        <Grid>
          <PriceButton
            selected={!isPrivate}
            onClick={() => (!disabled ? onSelectPrivate(false) : undefined)}
          >
            PUBLIC
          </PriceButton>
          <PriceButton
            selected={isPrivate}
            onClick={() => (!disabled ? onSelectPrivate(true) : undefined)}
          >
            PRIVATE
          </PriceButton>
        </Grid>
      </Section>
    </div>
  </Columns>
);

export default ContestTypeSection;
